import React from "react";
import { Modal, ModalBody } from "reactstrap";
import crossIcon from "assets/images/cross.svg";
import AddEvent from "accountOwner/pages/AddEvent";
import styles from "../../Dashboard.module.scss"

export default function SchedulerModal({
  isModalOpen,
  closeModalHandler,
  selectedOwnerId,
  onConfirm,
}) {
  return (
    <Modal
      isOpen={isModalOpen}
      toggle={closeModalHandler}
      className={`modal-lg modal-dialog-centered position-relative ${styles["dashboard-event-modal"]} `}
      modalClassName="custom-modal"
    >
      <span className="close-btn" onClick={closeModalHandler}>
        <img src={crossIcon} alt="close" />
      </span>
      <ModalBody>
        <AddEvent
          isInsideModal={true}
          selectedOwnerId={selectedOwnerId}
          onConfirm={onConfirm}
        />
      </ModalBody>
    </Modal>
  );
}
